import React from "react";
import classNames from "classnames";
import { Transaction } from "@common/types/transaction";
import { useIsDateLocked } from "@hooks/useIsDateLocked";
import { toDisplayDateOnly } from "@helpers/date";
import styles from "./RuleTransactionsPreview.module.scss";
import { MatchingPair } from "./MatchingPair";

interface Props {
    transaction: Transaction;
    pairedTransaction: Transaction;
    toggleTransaction: (transaction: Transaction) => void;
    isSelected: boolean;
    applyToExistingTransactions: boolean;
}

export const RuleTransactionPreview: React.FC<Props> = ({
    transaction,
    pairedTransaction,
    toggleTransaction,
    isSelected,
    applyToExistingTransactions,
}) => {
    const isLocked = useIsDateLocked(
        transaction.entity.id,
        toDisplayDateOnly(transaction.dateOnly ?? transaction.date),
    );
    const disabled = isLocked || !applyToExistingTransactions;
    return (
        <div
            className={classNames(styles.row, styles.bodyRow, {
                [styles.deselectedRow]: !isSelected || disabled,
            })}
        >
            <MatchingPair
                transaction={transaction}
                pairedTransaction={pairedTransaction}
                isChecked={!disabled && isSelected}
                isDisabled={disabled}
                toggle={toggleTransaction}
            />
        </div>
    );
};
